"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Text_1 = __importDefault(require("shared/components/Text"));
var ToolStatsSummary_1 = __importDefault(require("./SingleToolView/ToolStatsSummary"));
var PREFIX = 'SingleToolHeader';
var classes = {
    badge: "".concat(PREFIX, "-badge"),
};
var Root = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.badge)] = {
            padding: '2px 10px',
            border: '#CCCCCC solid 1px',
            borderRadius: 13,
            marginRight: theme.spacing(0.5),
            width: 'max-content',
            marginTop: theme.spacing(1.5),
        },
        _b);
});
var SingleToolHeader = function (_a) {
    var _b, _c;
    var toolStats = _a.toolStats, service = _a.service;
    return ((0, jsx_runtime_1.jsxs)(Root, __assign({ mb: 8 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: service, size: "xl", fontWeight: "medium" }) })), toolStats && (0, jsx_runtime_1.jsx)(ToolStatsSummary_1.default, { toolStats: toolStats }), (service === null || service === void 0 ? void 0 : service.description) && ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mt: 2 }, { children: service === null || service === void 0 ? void 0 : service.productDescription }))), ((_b = service === null || service === void 0 ? void 0 : service.categories) === null || _b === void 0 ? void 0 : _b[0]) && ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, className: classes.badge }, { children: (_c = service === null || service === void 0 ? void 0 : service.categories) === null || _c === void 0 ? void 0 : _c[0] })))] })));
};
exports.default = SingleToolHeader;
